package com.elan.edubridge.shared.domain.policy

import com.elan.edubridge.shared.domain.model.AppSection
import com.elan.edubridge.shared.domain.model.SessionState
import com.elan.edubridge.shared.domain.model.UserRole

/**
 * 세션 기준 권한 정책. RolePolicy는 그대로 두고 이 객체가 감싼다.
 */
object MembershipPolicy {
    /** 클라이언트가 스스로 부여할 수 있는 역할은 없다(§3, §5). */
    val clientGrantableRoles: Set<UserRole> = emptySet()

    fun canSelfAssign(role: UserRole): Boolean = role in clientGrantableRoles

    /** 보호자 동의 대기 계정은 홈 외 접근을 차단한다(§3). */
    fun sectionsFor(session: SessionState): List<AppSection> = when {
        !session.isAuthenticated -> emptyList()
        session.requiresGuardianConsent -> listOf(AppSection.HOME)
        else -> RolePolicy.sectionsFor(session.activeRole)
    }

    /** 스태프 콘솔(v4 대시보드·출결 QR) 진입 게이트(§5.2). VIEWER는 회원 뷰로 보낸다. */
    fun isStaff(session: SessionState): Boolean =
        !session.requiresGuardianConsent && RolePolicy.isStaff(session.activePermission)

    fun canManageAcademy(session: SessionState): Boolean =
        !session.requiresGuardianConsent && RolePolicy.canManageAcademy(session.activePermission)

    fun canManageUsers(session: SessionState): Boolean =
        !session.requiresGuardianConsent && RolePolicy.canManageUsers(session.activePermission)

    fun canManagePlatform(session: SessionState): Boolean =
        RolePolicy.canManagePlatform(session.activeRole)
}
